import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import config from 'config'
import pick from 'lodash/pick'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Spacer from 'atoms/Spacer'
import Fade from '@material-ui/core/Fade'
import CircularProgress from '@material-ui/core/CircularProgress'

// @todo Remove stripe.js from template.ejs

const styles = {
  container: {
    maxWidth: 400,
    minHeight: '2rem',
    display: 'flex',
    alignItems: 'center',
    '& > div': {
      width: '100%'
    }
  },
  containerInnerHidden: {
    visibility: 'hidden'
  }
}

const elementsStyle = theme => ({
  base: {
    color: theme.palette.secondary.dark,
    iconColor: theme.palette.secondary.dark,
    fontSize: theme.typography.fontSize,
    fontFamily: `${theme.typography.fontFamily}px`,
    fontSmoothing: 'antialiased',
    '::placeholder': {
      color: theme.palette.secondary.main
    }
  },
  invalid: {
    color: theme.palette.error.main,
    iconColor: theme.palette.error.main,
  }
})

export default
@withStyles(styles, { withTheme: true })
class BillingCardInput extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
  }

  state = {
    error: null,
    ready: false,
  }

  componentDidMount() {
    const { theme } = this.props
    this.stripe = Stripe(config.stripeKey)
    this.card = this.stripe.elements().create('card', {
      style: elementsStyle(theme),
      hidePostalCode: true,
    })
    this.card.on('change', this.handleCardChange)
    this.card.on('ready', this.handleCardReady)
    this.card.mount(this.container)
  }

  componentWillUnmount() {
    this.card.destroy()
  }

  createToken = () => {
    return this.stripe.createToken(this.card)
  }

  handleCardReady = () => {
    this.setState({ ready: true }, () => {
      this.card.focus()
    })
  }

  handleCardChange = (event) => {
    const { onChange } = this.props
    const { error } = event
    const data = {
      ...pick(event, 'error', 'complete', 'empty'),
      createToken: this.createToken,
    }
    this.setState({ error }, () => onChange(data))
  }

  cardContainerRef = (node) => {
    this.container = node
  }

  render() {
    const { classes } = this.props
    const { error, ready } = this.state
    return (
      <Fragment>
        <div className={classes.container}>
          { !ready && <CircularProgress size={24} color="secondary" /> }
          <div
            ref={this.cardContainerRef}
            className={classNames({ [classes.containerInnerHidden]: !ready })}
          />
        </div>
        <Fade in={!!error} mountOnEnter unmountOnExit exit={false}>
          <div>
            <Spacer small />
            <Typography variant="caption" color="error">
              { error && error.message }
            </Typography>
          </div>
        </Fade>
      </Fragment>
    )
  }
}
